import { render, staticRenderFns } from "./fitnessRecord.vue?vue&type=template&id=1d199c42&scoped=true&"
import script from "./fitnessRecord.vue?vue&type=script&lang=js&"
export * from "./fitnessRecord.vue?vue&type=script&lang=js&"
import style0 from "./fitnessRecord.vue?vue&type=style&index=0&id=1d199c42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d199c42",
  null
  
)

export default component.exports